import { RG53 } from "./CustomerGroupSalesWithGrowth/RG53";
import { RG27 } from "./SalesByChannelLastYearVSActualSales/RG27";

export const RegionGrowthPerformance = {
  "sections": [
    RG53,
    RG27
  ]
}